import { formatDateForFilename } from "@dana/Common/utils";

export interface DanaCoreReturnsData {
    email?: string;
    token?: string;
    dealerCode?: string;
    clientId?: string;
    clientSecret?: string;
    url?: string;
}

export interface DanaCoopData {
    email?: string;
    custom_sso_domain_name?: string;
    first_name?: string;
    last_name?: string;
    accessToken?: string;
    url?: string;
}

export async function getCoopToken(): Promise<DanaCoopData | undefined> {
    const response = await fetch("api/v1/dana/cooptoken", {
        method: "GET"
    });

    if (!response.ok) {
        return undefined;
    }

    let item = await response.json() as DanaCoopData;
    return item;
}

export async function getCoreReturnsToken(): Promise<DanaCoreReturnsData | undefined> {
    const response = await fetch("api/v1/dana/corereturnstoken", {
        method: "GET"
    });

    if (!response.ok) {
        return undefined;
    }

    let item = await response.json() as DanaCoreReturnsData;
    return item;
}

export async function downloadLeadTimes(): Promise<string | undefined> {
    const result = await fetch("api/v1/dana/downloadLeadTimes");
    if (result.ok) {
        let response = await result.json();
        return response.requestId;
    }
    return undefined;
}

export async function downloadPriceList(isFuture: boolean): Promise<string | undefined> {
    const result = await fetch(`api/v1/dana/${isFuture ? "downloadFuturePriceList" : "downloadPriceList"}`);
    if (result.ok) {
        let response = await result.json();
        return response.requestId;
    }
    
    return undefined;
}

export async function getCustomerScorecard(): Promise<string | undefined> {
    const result = await fetch('api/v1/dana/getCustomerScorecard');
    if (result.ok) {
        let response = await result.json();
        return response.requestId;
    }
    return undefined;
}

export async function checkLeadTimes(requestId: string, customerNumber: string): Promise<boolean> {
    const result = await fetch(`api/v1/dana/getLeadTimeRequestId?requestId=${requestId}`);
    if (result.ok) {
        const file = await result.blob()
        let a = document.createElement("a");
        a.href = URL.createObjectURL(file);
        const formattedDate = formatDateForFilename(new Date());
        a.setAttribute("download", `LeadTimes_${customerNumber}_${formattedDate}.xlsx`);
        a.click();
        return true;
    }
    if (result.status === 400 || result.status === 404) {
        return false;
    }
  
    return false;
}

export async function checkPriceList(requestId: string, customerNumber: string): Promise<boolean> {
    const result = await fetch(`api/v1/dana/getPriceListRequestId?requestId=${requestId}`);
    if (result.ok) {
        const file = await result.blob()
        let a = document.createElement("a");
        a.href = URL.createObjectURL(file);
        const formattedDate = formatDateForFilename(new Date());
        a.setAttribute("download", `PriceList_${customerNumber}_${formattedDate}.xlsx`);
        a.click();
        return true;
    }

     if (result.status === 400 || result.status === 404) {
        return false;
    }
  
    return false;
}

export async function checkCustomerScorecard(requestId: string, customerNumber: string): Promise<string | undefined> {
    const result = await fetch(`api/v1/dana/getCustomerScorecardRequestId?requestId=${requestId}`);
    if (result.ok) {
        const file = await result.blob()
        return URL.createObjectURL(file);
    }

    return undefined;
}

export async function emailCustomerScorecard(requestId: string, emails: string): Promise<boolean> {
    const result = await fetch(`api/v1/dana/emailCustomerScorecard`, {
        method: "POST",
        body: JSON.stringify({
            Emails: emails,
            RequestId: requestId
        }),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    });
    if (result.ok) {
        return true;
    }

    return false;
}

